export default __webpack_public_path__ + "static/media/9.393296e0.jpg";